// import React from 'react'

const pagebreak = ({ isEditing, item, isDragging }) =>
	/* 	item?.label ? (
		<h3
			style={{
				marginBottom: 0,
				marginTop: '18.72px',
				fontSize: '18.72px',
				padding: 2,
			}}
		>
			{item.label}
		</h3>
	) :  */ null

export default pagebreak
